class Clock {
  constructor(id) {
    if (!document.getElementById(id)) {
      return
    }

    this.timezone = parseInt(document.getElementById(id).dataset.timezone);
    this.offset = parseInt(document.getElementById(id).dataset.offset);

    if (this.isDST(new Date())) {
      this.timezone += 1;
    }

    this.handSeconds = document.querySelector(`#${id} .hand.seconds`);
    this.handMinutes = document.querySelector(`#${id} .hand.minutes`);
    this.handHours = document.querySelector(`#${id} .hand.hours`);

    this.getTime();
    this.cycle();
  }

  isDST(now) {
    const jan = new Date(now.getFullYear(), 0, 1);
    const jul = new Date(now.getFullYear(), 6, 1);
    const dst = Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());

    return now.getTimezoneOffset() < dst;
  }

  draw(hours, minutes, seconds) {
    const drawSeconds = ((seconds / 60) * 360) + 90;
    const drawMinutes = ((minutes / 60) * 360) + 90;
    const drawHours = ((hours / 12) * 360) + 90 + (minutes / 2);

    this.handSeconds.style.transform = `rotate(${drawSeconds}deg)`;
    this.handMinutes.style.transform = `rotate(${drawMinutes}deg)`;
    this.handHours.style.transform = `rotate(${drawHours}deg)`;

    // fix for animation bump on when clock hands hit zero
    if (drawSeconds === 444 || drawSeconds === 90) {
      this.handSeconds.style.transition = "all 0s ease 0s";
    } else {
      this.handSeconds.style.transition = "all 0.05s cubic-bezier(0, 0, 0.52, 2.51) 0s";
    }
  }

  getTime() {
    const now = new Date();

    let hours = now.getUTCHours() + this.timezone;
    let minutes = now.getUTCMinutes() + this.offset;
    // const seconds = now.getUTCSeconds();

    if (minutes >= 60) {
        hours++;
        minutes-=60;
    }
    this.draw(hours, minutes);
  }

  cycle() {
    setInterval(this.getTime.bind(this), 1000);
  }
}

new Clock('city-1');
new Clock('city-2');
new Clock('city-3');
new Clock('city-4');
new Clock('city-5');

$('.js-clockCity').each((index, el) => {
	const id = $(el).attr('id');
	new Clock(id);
});
